import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { getCounterValue } from '../../Counter'
import { FloatingTooltip } from '../../Floating'
import {
  getVerticalIconChevronDirection,
  ICON_COLOR,
  ICON_HEIGHT_16,
  IconChevron,
  IconNG,
} from '../../Icon'

import * as styles from './MultiValuedListMoreButton.module.css'

import DropdownIcon from '../../../icons/dropdown.svg'

function MultiValuedListMoreButton({
  className = styles.MultiValuedListMoreButton,
  closeTooltip = 'MultiValuedList.MoreButtonCloseTooltipKey',
  count,
  disabled,
  isDropdown,
  isOpen,
  openTooltip = 'MultiValuedList.MoreButtonOpenTooltipKey',
  ref,
  size,
  variant,
  ...buttonProps
}) {
  const { t } = useTranslation()

  const mods = {
    [styles.disabled]: disabled,
    [styles.dropdown]: isDropdown,
    [styles[size]]: !!size,
    [styles[variant]]: !!variant,
  }

  return (
    <FloatingTooltip
      content={
        isDropdown && !disabled ? t(isOpen ? closeTooltip : openTooltip) : null
      }
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <button
        {...buttonProps}
        className={classnames(className, mods)}
        ref={ref}
        type='button'
      >
        <span>{getCounterValue(count, true)}</span>
        {isDropdown ? (
          <IconNG
            Icon={IconChevron}
            color={ICON_COLOR.Without}
            iconProps={{
              Icon: DropdownIcon,
              direction: getVerticalIconChevronDirection(isOpen),
            }}
            size={ICON_HEIGHT_16}
          />
        ) : null}
      </button>
    </FloatingTooltip>
  )
}

export default MultiValuedListMoreButton
